import React from "react";
import { Link, useCurrentRoute, useView } from "react-navi";
import { MDXProvider } from "@mdx-js/react";
import ArticleMeta from "./ArticleMeta";
import Bio from "./Bio";
import styles from "./BlogPostLayout.module.css";

function BlogPostLayout({ blogRoot }) {
  let { title, data } = useCurrentRoute();
  let { connect, content, head } = useView();
  let { MDXComponent, readingTime } = content;

  return connect(
    <>
      {head}
      <article className={styles.container}>
        <header className={styles.header}>
          <h1 className={styles.title}>{title}</h1>
          <ArticleMeta
            blogRoot={blogRoot}
            meta={data}
            readingTime={readingTime}
          />
        </header>

        <div className={styles.articleCard}>
          <MDXProvider
            components={{
              a: Link,
              wrapper: ({ children }) => (
                <div className={styles.content}>{children}</div>
              ),
            }}
          >
            <MDXComponent />
          </MDXProvider>
        </div>

        <footer className={styles.footer}>
          <div className={styles.bioCard}>
            <Bio />
          </div>

          {(data.previousDetails || data.nextDetails) && (
            <nav className={styles.nav} aria-label="Post navigation">
              {data.previousDetails ? (
                <Link
                  className={styles.navLink}
                  href={data.previousDetails.href}
                >
                  <span className={styles.navLabel}>Previous</span>
                  <span className={styles.navTitle}>
                    &larr; {data.previousDetails.title}
                  </span>
                </Link>
              ) : (
                <span />
              )}
              {data.nextDetails ? (
                <Link
                  className={`${styles.navLink} ${styles.navLinkNext}`}
                  href={data.nextDetails.href}
                >
                  <span className={styles.navLabel}>Next</span>
                  <span className={styles.navTitle}>
                    {data.nextDetails.title} &rarr;
                  </span>
                </Link>
              ) : (
                <span />
              )}
            </nav>
          )}
        </footer>
      </article>
    </>
  );
}

export default BlogPostLayout;
